import { useState } from "react";
import About from "./components/About/About";
import Intro from "./components/Intro/Intro";
import Experience from "./components/Experience/Experience";
import ThemeButton from "./components/ThemeButton/ThemeButton";
import classes from "./App.module.scss";
import Skills from "./components/Skills/Skills";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer/Footer";

function App() {
  const [isDark, setIsDark] = useState(true);

  function themeHandler() {
    if (isDark) {
      setIsDark(false);
    } else {
      setIsDark(true);
    }
  }
  return (
    <>
      <ThemeButton isDark={isDark} themeHandler={themeHandler} />
      <div
        className={classes.wrapper}
        style={{
          backgroundColor: isDark ? "#090916" : "#FEFEFE",
          color: isDark ? "#fefefe" : "#090916",
        }}
      >
        <Intro isDark={isDark} />
        <About isDark={isDark} />
        <div className={classes.container}>
          <Skills isDark={isDark} />
          <Experience isDark={isDark} />
          <div
            className={classes.backgroundCircle}
            style={{
              border: isDark
                ? "2px solid rgba(254, 254, 254, 0.212)"
                : "2px solid rgba(9, 9, 22, 0.212)",
            }}
          >
            <div
              className={classes.innerCircle}
              style={{
                border: isDark
                  ? "2px solid rgba(254, 254, 254, 0.212)"
                  : "2px solid rgba(9, 9, 22, 0.212)",
                backgroundColor: isDark ? "#090916" : "#fefefe",
              }}
            ></div>
          </div>
        </div>
        <Projects isDark={isDark} />
        <Footer isDark={isDark} />
      </div>
    </>
  );
}

export default App;
